// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value-picker-question select {
    border: none;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 20px;
    -webkit-appearance: none;
    appearance: none;
    outline-offset: -1px;
    border-radius: var(--survey-input-border-radius, 2px);
    background: #FFF;
}

.value-picker-question .value-picker-select-wrapper {
    position: relative;
}

.value-picker-question .value-picker-select-icon {
    position: absolute;
    right: 10px;
    bottom: 13px;
    color: #555;
    pointer-events: none;
}

.value-picker-question.value-picker-question-v2 select {
    border: var(--v2-input-border);
    border-radius: 6px;
    padding: 12px 16px;
}

.value-picker-question.value-picker-question-v2 .value-picker-select-icon {
    bottom: 3px;
    right: 3px;
    height: calc(100% - 6px);
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFF;
    border-radius: 0px 6px 6px 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Questions/ValuePickerQuestion/ValuePickerQuestion.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;IACpB,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;AAClC","sourcesContent":[".value-picker-question select {\n    border: none;\n    padding: 10px;\n    width: 100%;\n    box-sizing: border-box;\n    font-size: 16px;\n    line-height: 20px;\n    -webkit-appearance: none;\n    appearance: none;\n    outline-offset: -1px;\n    border-radius: var(--survey-input-border-radius, 2px);\n    background: #FFF;\n}\n\n.value-picker-question .value-picker-select-wrapper {\n    position: relative;\n}\n\n.value-picker-question .value-picker-select-icon {\n    position: absolute;\n    right: 10px;\n    bottom: 13px;\n    color: #555;\n    pointer-events: none;\n}\n\n.value-picker-question.value-picker-question-v2 select {\n    border: var(--v2-input-border);\n    border-radius: 6px;\n    padding: 12px 16px;\n}\n\n.value-picker-question.value-picker-question-v2 .value-picker-select-icon {\n    bottom: 3px;\n    right: 3px;\n    height: calc(100% - 6px);\n    width: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n    border-radius: 0px 6px 6px 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
